// extracted by mini-css-extract-plugin
module.exports = {"profilePhoto":"Dw5cuNwR","contentClose":"c-8EEhie","icon":"H69y-9Iw","rotate":"_1XHWjaNe","contentFade":"TDPWAWSm","starColor":"_28iw4DNb"};